import {BehaviorSubject, Observable, of} from 'rxjs';
import {catchError, map, shareReplay, timeout} from 'rxjs/operators';
import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {NotificationService} from './notification.service';
import {isPlatformBrowser} from '@angular/common';
import {ConstantsService as ConstantsHttpService, GetConstants200ResponseApiModel} from 'api-client';
import {environment} from '../environments/environment';

@Injectable({
  providedIn: 'root'
  })
export class ConstantsService {
    public readonly baseUrl = environment.baseUrl;

    private readonly constants$: Observable<Partial<GetConstants200ResponseApiModel>>;

    public podioAppId$: Observable<GetConstants200ResponseApiModel['podioAppId'] | undefined>;
    public registerUri$: Observable<GetConstants200ResponseApiModel['registerUri'] | undefined>;
    public stripeBaseUrl$: Observable<GetConstants200ResponseApiModel['stripeBaseUrl'] | undefined>;
    public paymentPublicKey$: Observable<GetConstants200ResponseApiModel['payment_publik_key'] | undefined>;
    public redirectUri$: Observable<GetConstants200ResponseApiModel['redirectUri'] | undefined>;
    public enableOAuth$: Observable<GetConstants200ResponseApiModel['enableOAuth'] | undefined>;

    private readonly downloadTokenSubject = new BehaviorSubject<string | null>(null);
    public readonly downloadToken$ = this.downloadTokenSubject.asObservable();

    private readonly hostSubject = new BehaviorSubject<string>('');
    public readonly host$ = this.hostSubject.asObservable();

    constructor(private constantsHttpService: ConstantsHttpService, notify: NotificationService, @Inject(PLATFORM_ID) private platformId: Object) {
      this.constants$ = this.constantsHttpService.getConstants().pipe(
        timeout(5000),
          catchError(error => {
            notify.notify(error.message, 'Could not load constants!', 'error');
            return of({});
          }),
          shareReplay(1)
        );

        this.podioAppId$ = this.selectConstant('podioAppId');
        this.registerUri$ = this.selectConstant('registerUri');
        this.stripeBaseUrl$ = this.selectConstant('stripeBaseUrl');
        this.paymentPublicKey$ = this.selectConstant('payment_publik_key');
        this.redirectUri$ = this.selectConstant('redirectUri');
        this.enableOAuth$ = this.selectConstant('enableOAuth');

        if (isPlatformBrowser(this.platformId)) {
          this.hostSubject.next(window.location.host);
        }
    }

    public setDownloadToken(token: string | null) {
        this.downloadTokenSubject.next(token);
    }

    private selectConstant<K extends keyof GetConstants200ResponseApiModel>(key: K): Observable<Partial<GetConstants200ResponseApiModel>[K]> {
        return this.constants$.pipe(map(constants => constants[key]));
    }

}
